<template>
  <div>
    <page-header
      title="Credit and Debits"
      breadcrumb="Accounting > Credits and Debits"
    />
    <div class="bg-white mb-3 flex items-center">
      <div class="w-3/12 px-2 border-none">
        <span
          class="block py-1 border-b-2 border-gray-200 text-primary-yellow border-dashed"
          >Total Outstanding</span
        >
        <div class="my-2 flex items-center w-full">
          <p class=" w-1/2">
            <abbr class="text-xs block w-full">Credit</abbr>
            ₦ 2,157,667.15
          </p>
          <p class="pl-1 flex justify-end w-1/2">
            <GraphIcon type="success" />
          </p>
        </div>
      </div>

      <div class="w-3/12 px-2 border-none">
        <span
          class="flex items-center py-1 text-right border-b-2 border-gray-200 border-dashed justify-end"
        >
          <abbr class="border-r-2 border-gray-200 pr-2">since: </abbr><span class="pl-2">
           <select class="border-none w-28 outline-none text-xs opacity-75">
            <option>Last 3 Months</option>
           </select>
          </span></span
        >
        <div class="my-2 flex items-center w-full">
          <p class=" w-1/2">
            <abbr class="text-xs block w-full">Debit</abbr>
            ₦ 2,157,667.15
          </p>
          <p class="pl-1 flex justify-end w-1/2"><GraphIcon type="loss" /></p>
        </div>
      </div>

      <div class="w-6/12 px-2 flex flex-wrap">
        <span
          class="py-1 w-full text-right border-b-2 border-gray-200  border-dashed text-primary-yellow flex justify-between items-center"
          >Account Position (YTD)
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </span>
        <div class="py-3 flex w-full">
          <p class="w-4/12 border-r-2 border-gray-300 text-center">
            <small>Credit Total</small><br />
            ₦ 42,160,069
          </p>
          <p class="w-4/12 border-r-2 border-gray-300 text-center">
            <small>Debit Total</small><br />
            ₦ 42,160,069
          </p>
          <p class="w-4/12 text-center">
            <small>Net Account Postion</small><br />
            <abbr class=" text-primary-green">₦ 42,160,069</abbr>
          </p>
        </div>
      </div>
    </div>

    <div class="bg-white p-3">
      <div class="flex border-b-2 border-gray-400 pt-3 px-3 bg-white">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'credit' }"
          @click="currentTab = 'credit'"
        >
          <p>Credit Account</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'debit' }"
          @click="currentTab = 'debit'"
        >
          <p>Debit Account</p>
        </div>
      </div>
      <div class="py-2 pt-3">
        <div class="table__search-input-wrapper w-64 opacity-75">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="searchString"
          />
          <img
            class="cursor-pointer"
            src="@/assets/images/icons/search.svg"
            alt="search icon"
          />
        </div>
      </div>
    </div>

    <div class="p-2 mb-2 bg-white mt-2">
      <div class="flex items-center pt-2">
        <div class="col-md-3 flex items-center">
          <img src="@/assets/images/icons/filter-icon.svg" class="mr-2" />
          <span class="w-48">
            <el-select
              class="mt-1"
              v-model="location"
              placeholder="--Select Location--"
            >
              <el-option
                v-for="type in ['cardTypes']"
                :key="type"
                :label="type"
                :value="type"
              >
              </el-option>
            </el-select>
          </span>
        </div>
        <div
          class="col-md-6 col-12 flex items-center border-r-2 border-gray-200"
        >
          <label class="mr-2">From:</label>
          <el-date-picker />
          <label class="mx-2">To:</label>
          <span class="w-28"><el-date-picker /></span>
          <img src="@/assets/images/icons/reload-icon.svg" class="ml-2" />
        </div>

        <div class="col-md-3 flex items-center">
          <span class="w-48">
            <el-select
              class="mt-1"
              v-model="location"
              placeholder="--TransactionType--"
            >
              <el-option
                v-for="type in ['cardTypes']"
                :key="type"
                :label="type"
                :value="type"
              >
              </el-option>
            </el-select>
          </span>
        </div>
      </div>
    </div>

    <div>
      <CreditDebitTable />
      <PaginationControl
        :total="totalCollection"
        :pageNumber="sortOptions.sortOptions"
        @pageNumber="setPageDisplayCollection"
        @pageSize="setNumDisplayCollection"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import GraphIcon from "@/assets/images/accounting/GraphIcon.vue";
import CreditDebitTable from "@/components/3pl/Accounting/CreditDebitTable.vue";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: { PageHeader, GraphIcon, CreditDebitTable, PaginationControl },
  data() {
    return {
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
      currentTab: "credit",
      vatAnalysis: [
        {
          name: "Totals VAT on Sales",
          market: "success",
        },
        {
          name: "Totals VAT on Purchase",
          market: "loss",
        },
      ],
    };
  },
  methods: {
    setNumDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
